'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.values = exports.N = exports.X = exports.R = exports.D = exports.P = exports.K = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _params;

exports.getCaption = getCaption;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @Conf
// #hasDoc=true

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2024-04-03T14:18:38Z                      #

// ##############################################################

/**
 * Typ adresy. @author Pavel Stánek [pavel.stanek@marbes.cz] @since 26.01.2017
 */

/**
 * Klasická adresa.
 */
var K = exports.K = 'K';

/**
 * Poštovní přihrádka.
 */
var P = exports.P = 'P';

/**
 * Dodávací schrána.
 */
var D = exports.D = 'D';

/**
 * Poste restante.
 */
var R = exports.R = 'R';

/**
 * Nestrukturovaná adresa.
 */
var X = exports.X = 'X';

/**
 * Neuvedena.
 */
var N = exports.N = 'N';

/**
 * Seznam všech hodnot.
 */
var values = exports.values = [K, P, D, R, X, N];

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
var params = (_params = {}, (0, _defineProperty3.default)(_params, K, { caption: 'Klasická adresa.' }), (0, _defineProperty3.default)(_params, P, { caption: 'Poštovní přihrádka.' }), (0, _defineProperty3.default)(_params, D, { caption: 'Dodávací schrána.' }), (0, _defineProperty3.default)(_params, R, { caption: 'Poste restante.' }), (0, _defineProperty3.default)(_params, X, { caption: 'Nestrukturovaná adresa.' }), (0, _defineProperty3.default)(_params, N, { caption: 'Neuvedena.' }), _params);

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
function getCaption(value) {
  return params[value].caption;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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